module.exports = __webpack_public_path__ + "static/media/menu-burger.80add31d.svg";